<app-temp-modal-cadastro #modalConsultar textHeader="Importação NF-e Própria" (closed)="onClose()"
  customClass="modal-lg" [modalContentId]="'modal-cte-importar-nfe-propria'">
  <div class="app-modal-body">
    <ng-container *ngIf="passo === 'IMPORTAR'">
      <form [formGroup]="form">
        <div class="row">
          <div class="form-group col-sm-12">
            <label for="modal-cte-importar-nfe-search">Pesquisar</label>
            <input id="modal-cte-importar-nfe-search" type="text" class="form-control" formControlName="search"
              placeholder="Pesquisar">
          </div>
        </div>
      </form>

      <h4 *ngIf="!notasFiscais" class="text-center"><i class="fa fa-circle-notch fa-spin"></i></h4>
      <ng-container *ngIf="notasFiscais">
        <app-dim-datatable [loading]="loading.consulta" [totalItems]="10" [data]="notasFiscais.items"
          [columns]="columns" [selectable]="true" [selecionados]="notasSelecionadas" (sorting)="onSortNotas($event)"
          [showPagination]="false">
        </app-dim-datatable>
      </ng-container>

      <button class="btn btn-primary" (click)="importar()" [disabled]="notasSelecionadas.length === 0 || loading.importar">
        <app-loading [loading]="loading.importar" texto="Importar"></app-loading>
      </button>
    </ng-container>

    <div *ngIf="passo === 'ERROS'">
      <div class="alert alert-danger text-danger">
        A importação retornou erros. Se continuar essas notas serão ignoradas.
      </div>

      <ul>
        <li *ngFor="let erro of importacao.erros" class="mt-3">
          {{ erro }}
        </li>
      </ul>

      <div class="text-center m-t-20">
        <button class="btn btn-primary" (click)="continuar()">
          Continuar
        </button>
        <button class="btn btn-info" (click)="voltar()">
          Voltar
        </button>
      </div>
    </div>
  </div>

  <div class="app-modal-footer">
  </div>
</app-temp-modal-cadastro>